import { Core } from '../../Constants';
export function Mixin(Base) {
    class Class extends Base {
        get supportedOperations() {
            return this.getArray(Core.Vocab('supportedOperation'));
        }
        get supportedProperties() {
            return this.getArray(Core.Vocab('supportedProperty'));
        }
    }
    return Class;
}
export const shouldApply = (res) => res.types.contains((Core.Vocab('Class')));
//# sourceMappingURL=Class.js.map